export default __webpack_public_path__ + "static/1271-c7798e5ce5ee489d8f83d95a7996a650.gif";